import { Component, Input } from '@angular/core';
import {
  ComponentRendering,
  JssModule,
} from '@sitecore-jss/sitecore-jss-angular';
import {
  ExperienceEditorComponent,
  ExperienceEditorLiveDirective,
  ExperienceEditorPreviewDirective,
} from '@core/experience-editor-components';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

@Component({
  selector: 'wl-anchor',
  templateUrl: './anchor.component.html',
  styleUrls: ['./anchor.component.scss'],
  standalone: true,
  imports: [
    ExperienceEditorComponent,
    ExperienceEditorLiveDirective,
    ExperienceEditorPreviewDirective,
    FaIconComponent,
    JssModule,
  ],
})
export class AnchorComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering?: ComponentRendering;
}
